<template>
  <div>
    <CCard class="bg-style2">
      <CCardHeader class="bg-gradient-danger text-white" style="border-top-left-radius: 1rem; border-top-right-radius: 1rem ">
        <span class="font-weight-bold h6"> <CIcon v-if="icon" :name="icon"/> {{ caption }} </span>

        <div class="card-header-actions">
          Total : {{item.length}}
        </div>

      </CCardHeader>
      <CCardBody>
        <CButton
            color="primary"
            class="mb-2"
            @click="download('123123ss')"
        >
          Download current items (.csv)
        </CButton>

        <CDataTable
            :table-filter="{label:''}"
            :hover="hover"
            :striped="striped"
            :bordered="bordered"
            :small="small"
            :fixed="fixed"
            :items="item"
            :fields="fields"
            :items-per-page="small ? 50 : 20"
            :dark="dark"
            :loading="loading"
            pagination
            :items-per-page-select="pages"
            sorter
        >
          <template #index="{item,index}">
            <td class="text-center"  @click="toggleDetails(item, index)"> {{ index + 1 }}</td>
          </template>


          <template #completed="{item,index}">
            <td class="text-center" > {{ item.completed }} {{ '( ' + ((item.completed / item.total) * 100).toFixed(2) + '% )' }}</td>
          </template>

          <template #total="{item,index}">
            <td class="text-center" > {{ item.total }}</td>
          </template>

          <template #pending="{item,index}">
            <td class="text-center" > {{ item.pending }} {{ '( ' + ((item.pending / item.total) * 100).toFixed(2) + '% )' }}</td>
          </template>

          <template #doing="{item,index}">
            <td class="text-center" > {{ item.doing }} {{ '( ' + ((item.doing / item.total) * 100).toFixed(2) + '% )' }}</td>
          </template>

<!--          <template #member="{item,index}">-->
<!--            <td class="text-center" @click="toggleDetails(item, index)">-->
<!--              {{ item.total }}-->
<!--            </td>-->
<!--          </template>-->

          <template #isNoGap="{item,index}">
            <td class="text-center" > {{ item.isNoGap }} {{ '( ' + ((item.isNoGap / item.total) * 100).toFixed(2) + '% )' }}</td>
          </template>

          <template #isGap="{item,index}">
            <td class="text-center" > {{ item.isGap }} {{ '( ' + ((item.isNoGap / item.total) * 100).toFixed(2) + '% )' }}</td>
          </template>

          <template #action="{item,index}">
            <td style="width: 140px">
              <CRow>
                <CCol class="text-center">
                  <CButton class="mr-1"  size="sm" color="info" shape="pill" variant="outline" @click="toggleDetails(item, index)"  >
                    <CIcon name="cil-description"/>
                  </CButton>

                </CCol>
              </CRow>
            </td>
          </template>
          <template #details="{item,index}">
            <CCollapse :show="Boolean(item._toggled)" :duration="collapseDuration">
              <CRow>
                <CCol>
<!--                  {{index+1 +' - '+ item.code +' '+ item.title}}-->
                  {{ item.title }}
                </CCol>
              </CRow>
              <CRow class="mt-3">
                <CCol>
                  <ReportCompetency2 class="mb-3" :item="item.explorerAgency" :loading="loading" />
                </CCol>
              </CRow>
            </CCollapse>
          </template>

        </CDataTable>
      </CCardBody>
    </CCard>

  </div>
</template>

<script>

import {mapGetters} from 'vuex'
import * as XLSX from "xlsx";
import Vue from 'vue'
import moment from "moment";

import {CChartDoughnut} from '@coreui/vue-chartjs'
import ReportCompetency2 from "@/projects/views/E-Performances/Dashboard/Admin/components/ReportCompetency2";

export default {
  components: {ReportCompetency2, CChartDoughnut},
  name: 'AssessmentSummary',
  props: {
    icon: {
      type: String,
      default: 'cil-user'
    },
    caption: {
      type: String,
      default: 'Banks'
    },

    item:{
      type: Array,
      default() {
        return []
      }
    },
    fields: {
      type: Array,
      default() {
        return [
          {key:"index", label: "#",  _style: 'width:50px; text-align: center'},
          {key:"code", label:"Code", _style: 'width:30px; text-align: center'},
          {key:"title", label:"Title", },
          {key:"member", label: "Total",_style: 'width:30px; text-align: center' },

          {key:"isGap", label: "Gap found",_style: 'width:150px; text-align: center' },
          {key:"isNoGap", label: "No Gap",_style: 'width:150px; text-align: center' },
          // {key:"isMeets", label: "Meets", _style: 'width:150px; text-align: center'},
          // {key:"isExceeding", label: "Exceeding", _style: 'width:150px; text-align: center'},

          {key:"action", label: "#", _style: 'width:30px; text-align: center'}
        ]
      }
    },
    childrenFields: {
      type: Array,
      default() {
        return [
          {key:"index", label: "#",  _style: 'width:50px; text-align: center'},
          {key:"year", label:"year", _style: 'width:50px; text-align: center'},
          {key:"code", label:"รหัสพนักงาน", _style: 'width:120px;'},
          {key:"info", label:"ชื่อ - นามสกุลพนักงาน" , _style: 'width:300px;'},
          {key:"cc", label:"ชื่อรายการสมรรถนะ", _style: 'width:350px;'},
          {key:"competencyLevel", label:"ระดับที่คาดหวัง",_style: 'width:120px; text-align: center' },
          {key:"assessment0", label:"ประเมินตนเอง", _style: ' width:120px; text-align: center' },
          {key:"assessment1", label:" ผู้ประเมิน 1", _style: ' width:120px; text-align: center' },
          {key:"assessment2", label:" ผู้ประเมิน 2", _style: ' width:120px; text-align: center' },
          {key:"gapSum", label:" สรุปผล", _style: ' width:120px;text-align: center' },
        ]
      }
    },
    type: {
      type: String,
      default: 'cil-user'
    },
    hover: Boolean,
    striped: Boolean,
    bordered: Boolean,
    small: Boolean,
    fixed: Boolean,
    dark: Boolean,

    pages:{
      type: Object,
      default() {
        return {
          values:[10,20,50,100]
        }
      }
    },
    loading:{
      type: Boolean,
      default() {
        return false
      }
    },
    disable: {
      type: Boolean,
      default() {
        return false
      }
    }
  },

  data: function () {
    return {
      collapseDuration: 0,
      defaultDatasets: [{
        backgroundColor: [
          '#636f83',
          '#f9b115',
          '#2eb85c',
        ],
        data: [40, 20, 10]
      }]

    }
  },

  mounted() {


  },

  created() {
    this.onInit()


  },
  beforeDestroy() {

  },

  methods: {
    onInit() {
      this.onLoad();
      console.log(this.item)
      var objs = this.item

      var objsArray = [];
      for(var i=0; i<objs.length; i++){
        var objCC = [];

        var data = {};
        data.code = objs[i].code;
        data.title = objs[i].title;
        data.tital = objs[i].member;
        data.gapFound = objs[i].isGap + ' ( ' + ((objs[i].isGap / objs[i].total) * 100).toFixed(2) + '% )' ;
        data.noFound = objs[i].isNoGap + ' ( ' + ((objs[i].isNoGap / objs[i].total) * 100).toFixed(2) + '% )' ;


        for(var j=0; j<objs[i].explorerAgency.length; j++){
          var objsExplorer = {};
          objsExplorer.title = objs[i].explorerAgency[j].title
          objsExplorer.total = objs[i].explorerAgency[j].total
          objsExplorer.gapFound = objs[i].explorerAgency[j].isGap + ' ( ' + ((objs[i].explorerAgency[j].isGap / objs[i].explorerAgency[j].total) * 100).toFixed(2) + '% )' ;
          objsExplorer.noFound = (objs[i].explorerAgency[j].total - objs[i].explorerAgency[j].isGap) + ' ( ' + (( (objs[i].explorerAgency[j].total - objs[i].explorerAgency[j].isGap) / objs[i].explorerAgency[j].total) * 100).toFixed(2) + '% )' ;
          objsExplorer.isMeets = objs[i].explorerAgency[j].isMeets + ' ( ' + ((objs[i].explorerAgency[j].isMeets / objs[i].explorerAgency[j].total) * 100).toFixed(2) + '% )' ;
          objsExplorer.isExceeding = objs[i].explorerAgency[j].isExceeding + ' ( ' + ((objs[i].explorerAgency[j].isExceeding / objs[i].explorerAgency[j].total) * 100).toFixed(2) + '% )' ;

          objCC.push(objsExplorer)

        }

        data.history = objCC;



        objsArray.push(data)

      }


      console.log(2,objsArray)
    },

    onLoad() {

    },

    download(name) {

      var objs = this.item

      var objsArray = [];
      for(var i=0; i<objs.length; i++){
        var objCC = [];

        var data = {};
        data.code = objs[i].code;
        data.title = objs[i].title;
        data.tital = objs[i].member;
        data.gapFound = objs[i].isGap + ' ( ' + ((objs[i].isGap / objs[i].total) * 100).toFixed(2) + '% )' ;
        data.noFound = objs[i].isNoGap + ' ( ' + ((objs[i].isNoGap / objs[i].total) * 100).toFixed(2) + '% )' ;


        for(var j=0; j<objs[i].explorerAgency.length; j++){
          var objsExplorer = {};
          objsExplorer.title = objs[i].explorerAgency[j].title
          objsExplorer.total = objs[i].explorerAgency[j].total
          objsExplorer.gapFound = objs[i].explorerAgency[j].isGap + ' ( ' + ((objs[i].explorerAgency[j].isGap / objs[i].explorerAgency[j].total) * 100).toFixed(2) + '% )' ;
          objsExplorer.noFound = (objs[i].explorerAgency[j].total - objs[i].explorerAgency[j].isGap) + ' ( ' + (( (objs[i].explorerAgency[j].total - objs[i].explorerAgency[j].isGap) / objs[i].explorerAgency[j].total) * 100).toFixed(2) + '% )' ;
          objsExplorer.isMeets = objs[i].explorerAgency[j].isMeets + ' ( ' + ((objs[i].explorerAgency[j].isMeets / objs[i].explorerAgency[j].total) * 100).toFixed(2) + '% )' ;
          objsExplorer.isExceeding = objs[i].explorerAgency[j].isExceeding + ' ( ' + ((objs[i].explorerAgency[j].isExceeding / objs[i].explorerAgency[j].total) * 100).toFixed(2) + '% )' ;

          objCC.push(objsExplorer)

        }
        data.history = objCC;

        objsArray.push(data)

      }




      const wb = XLSX.utils.book_new()
      for(var i=0; i<objsArray.length; i++){
        var nameSheet = objsArray[i].code.toString()


        const summary = [
          { Title: objsArray[i].title, Total: objsArray[i].total, GapFound: objsArray[i].gapFound, NoGap: objsArray[i].noFound },
        ];

        // ข้อมูลย่อย (จาก history)
        const details = objsArray[i].history.map((historyItem) => ({
          Title: historyItem.title,
          Total: historyItem.total,
          GapFound: historyItem.gapFound,
          NoGap: historyItem.noFound,
          Meets: historyItem.isMeets,
          Exceeding: historyItem.isExceeding,
        }));

        const sheetData = [{ Title: "Title", Total: "Total", GapFound: "Gap found", NoGap: "No Gap"},...summary, {},{ Title: "Title", Total: "Total", GapFound: "Gap found", NoGap: "No Gap", Meets: "Meets", Exceeding: "Exceeding" }, ...details]

        // แปลงข้อมูลเป็น sheet
        const dataX = XLSX.utils.json_to_sheet(sheetData, { skipHeader: true });


        // const dataX = XLSX.utils.json_to_sheet(objsArray[i].history)
        XLSX.utils.book_append_sheet(wb, dataX, nameSheet)
      }
      XLSX.writeFile(wb,name+'.xlsx')
    },

    onDataChart(item){
      return  [{
        backgroundColor: [
          '#636f83',
          '#f9b115',
          '#2eb85c',
        ],
        data: [item.pending, item.doing, item.completed]
      }]
    },

    onDataChart2(item){
      console.log(item)
      return  [{
        backgroundColor: [
          '#f9b115',
          '#2eb85c',
        ],
        data: [item.isGap, item.isNoGap]
      }]
    },

    toggleDetails (item,index) {
      item._toggled = !item._toggled
      this.collapseDuration = 300
      this.$nextTick(() => { this.collapseDuration = 0})

      // this.$emit('info',item)
    },
    color(level,checck){
      if(level > checck){
        return "text-danger"
      }else if(level == checck){
        return "text-success"
      }else{
        return "text-info"
      }

    }
  },

  computed: {
    ...mapGetters({
      lang: "setting/lang",
    }),
    // csvContent () {
    //   return this.item.map(item => Object.values(item).join(',')).join('\n')
    // },
    // csvCode () {
    //   return 'data:text/csv;charset=utf-8,SEP=,%0A' + encodeURIComponent(this.csvContent)
    // }
  },

  watch: {}
}
</script>
<style>

.w50 {
  min-width: 50%;
}

.input-group-append .form-group {
  margin-bottom: 0px;
}

.text-right {
  text-align: end;
}

.bg-login1 {
  border-radius: 1.5rem;
  background: linear-gradient(180deg, #a54af0 0%, #539cf8 60%, #C8CED3 80%);
}
</style>
